import { mapActions, mapGetters } from 'vuex'

import { Colors, Services, joinURLPath } from '@sigma-frontend-libs/commons'
import { isUUID } from '@sigmasms/commons'

import { balance, createClicker, generateServices, globalErrorHandler, request } from '@/utils'

import generatorSearch from '@/components/generator/search'
import { inputFilter, outputFilter } from '@/components/services/users/utils'
import templateLegacy from '@/components/templates/legacy'

import render from './render'

export default {
  name: Services.users,

  mixins: [
    balance(),
    generateServices([
      {
        name: Services.billings,

        inputFilter(result) {
          result.amount = 10

          return result
        },

        outputFilter(result) {
          if (result.source !== 'accrual') {
            result.amount = result.amount * -1
          }

          result.amount = parseFloat(result.amount)

          return result
        },

        get: false,
        find: false,
        update: false,
        remove: false
      },
      {
        name: Services.users,

        inputFilter,
        outputFilter,

        create: {
          redirect: true,
          params: {
            query: {
              $scope: [ 'full' ]
            }
          }
        },

        find: false,
        get: false,
        update: false,
        remove: false
      }
    ])
  ],

  components: {
    'search-generator': generatorSearch({
      name: Services.users,

      find: {
        defaultFilter: {
          isActive: true
        },
        params: {
          query: {
            $scope: [ 'full' ]
          }
        }
      }
    }),

    'legacy-template': templateLegacy({
      name: Services.users,

      inputFilter,
      outputFilter,

      find: false,
      get: {
        params: {
          query: {
            $scope: [ 'full' ]
          }
        }
      },
      update: {
        params: {
          query: {
            $scope: [ 'full' ]
          }
        }
      },
      create: false,
      remove: {
        redirect: true,
        params: {
          query: {
            $scope: [ 'full' ]
          }
        }
      }
    })
  },

  data() {
    return {
      showUserCreateDialog: false,
      showAddFundsDialog: false,
      showTokenDialog: false,

      tab: undefined,
      token: undefined
    }
  },

  computed: {
    ...mapGetters({ statusLoginAs: 'login/status' }),

    createDataIsValid() {
      return this.restData.billings.create.state !== 'loading' && this.restData.billings.create.isValid
    },

    tabs() {
      const result = []
      if (this.checkPermissions(`advanced.${Services.userComments}.get`)) {
        result.push(Services.userComments)
      }
      if (this.checkPermissions(`advanced.${Services.eventsHistory}.get`)) {
        result.push(Services.eventsHistory)
      }

      return result.map(key => {
        return {
          key,
          title: this.getTranslate(`${Services.users}.tabs.${key}`)
        }
      })
    }
  },

  mounted() {
    this.tab = this.tabs[0]?.key
  },

  methods: {
    ...mapActions({ loginAs: 'login/loginAs' }),

    clickHandler: createClicker({
      shortClickHandler(event) {
        if (event.shiftKey) {
          this.showUserToken()
        } else {
          this.loginAs(this.$route.params.id)
        }
      },

      longClickHandler() {
        this.showUserToken()
      },

      longClickPreFire: true
    }),

    async showUserToken() {
      try {
        if (isUUID(this.$route.params.id)) {
          const response = await request.get(joinURLPath('login', 'as', this.$route.params.id))
          if (response?.token) {
            this.token = response.token
            this.showTokenDialog = true
          }
        }
      } catch (error) {
        globalErrorHandler(error)
      }
    },
    closeTokenDialog() {
      this.showTokenDialog = false
      this.token = undefined
    },
    copyToken() {
      navigator.clipboard.writeText(this.token)
      this.addSnackbar({
        text: this.getTranslate('misc.copied'),
        color: Colors.success
      })
      this.closeTokenDialog()
    },

    async createBilling() {
      if (this.createDataIsValid) {
        try {
          const result = await this.rest.billings.create(this.restData.billings.create.data)
          if (result) {
            this.showAddFundsDialog = false
          }
        } catch (error) {
          globalErrorHandler(error)
        }
      }
    },

    async createUser() {
      if (this.restData[Services.users].create.isValid) {
        try {
          const result = await this.rest[Services.users].create(this.restData[Services.users].create.data)
          if (result) {
            this.showUserCreateDialog = false
          }
        } catch (error) {
          globalErrorHandler(error)
        }
      }
    }
  },

  render
}
